import React, { useState, useEffect } from "react";
import { Input } from "../../../../CommonUIComponents/Input/Input";
import { TextArea } from "../../../../CommonUIComponents/TextArea/TextArea";
import {
  saveSimulateHeaderTitle,
  ScenarioName,
  ScenarioDescription,
  sceanrioNameTooltip,
  scenarioDesctooltip,
  scenarioNameRegexp,
  scenarioDescRegexp,
  scenarioNameLength,
  scenarioDescLength,
  maxLength100,
  maxLength2000,
  scenarioNameRequiredError,
  commonError,
  wafErrorMessage
} from "../../../../../util/constants";
import {
  setScenarioName,
  setScenarioDesc,
  setIsNextTabButtonDisabled
} from "../../../../../store/slices/simulateSlice";
import { useDispatch, useSelector } from "react-redux";
import { LoadingIndicatorEmbed } from "../../../../CommonUIComponents/LoadingIndicator/LoadingIndicatorEmbed";
import { Tooltip } from "../../../../CommonUIComponents/Tooltip/Tooltip";
import { EmissionIcon } from "../../../../../icons";
import { setWafErrorFlag } from "../../../../../store/slices/projectSlice";

export function SaveScenario() {
  const dispatch = useDispatch();
  const simulate = useSelector((state) => state.simulate.scenario);
  const isEditScenario = useSelector((state) => state.simulate.isEditScenario);
  const wafErrorFlag = useSelector((state) => state.project.wafErrorFlag);
  const [loader, showLoader] = useState(true);
  const [senarioNameErrorMessage, setSenarioNameErrorMessage] = useState("");
  const [scenarioDescErrorMessage, setScenarioDescErrorMessage] = useState("");
  const [wafErrorMessageState, setWafErrorMessageState] = useState("");

  useEffect(() => {
    if (isEditScenario) {
      showLoader(true);
    } else {
      showLoader(false);
    }
  }, [isEditScenario]);

  useEffect(() => {
    if (wafErrorFlag) {
      setWafErrorMessageState(wafErrorMessage);
    }
  }, [wafErrorFlag]);

  useEffect(() => {
    if (simulate.scenarioName) {
      showLoader(false);
    }
  }, [simulate.scenarioName]);

  // On change scenario name and description
  const handleOnChange = async (event, fieldName) => {
    dispatch(setWafErrorFlag(false));
    if (fieldName === "ScenarioName") {
      let error = "";
      // Always update the value to allow typing/pasting
      dispatch(setScenarioName({ name: event.target.value }));
      
      // Check validations
      if (event.target.value?.length >= maxLength100) {
        // Length exceeds 100 characters
        error = scenarioNameLength;
      } else if (!scenarioNameRegexp?.test(event.target.value) || event.target.value === "-") {
        // Invalid characters
        error = commonError;
      } else if (event.target.value === "") {
        // Empty (required)
        error = scenarioNameRequiredError;
      }
      
      setSenarioNameErrorMessage(error);
    }
    if (fieldName === "ScenarioDesc") {
      let error = "";
      // Always update the value to allow typing/pasting
      dispatch(setScenarioDesc({ descrp: event.target.value }));
      // Check validations
      if (event.target.value?.length >= maxLength2000) {
        // Length exceeds 2000 characters
        error = scenarioDescLength;
      } else if (!scenarioDescRegexp.test(event.target.value) || event.target.value === "-") {
        // Invalid characters
        error = commonError;
      }
      
      setScenarioDescErrorMessage(error);
    }
  };

  // Disable Save button on basis of empty fields and validation errors
  if (scenarioNameRegexp?.test(simulate?.scenarioName) && simulate?.scenarioName !== ""
    && scenarioDescRegexp.test(simulate?.scenarioDescrption)
    && !senarioNameErrorMessage
    && !scenarioDescErrorMessage) {
    dispatch(setIsNextTabButtonDisabled({ isDisabled: false }));
  } else {
    dispatch(setIsNextTabButtonDisabled({ isDisabled: true }));
  }

  return (
    <>
      <LoadingIndicatorEmbed
        show={loader}
        className={"decarb-loading-indicator-transparent"}
      >
        <div className="save-new-scenario-content-body">
          <div className="save-new-scenario-content-body-header">
            <span>{saveSimulateHeaderTitle}</span>
          </div>
          <div className="save-new-scenario-content-body">
            <div className="save-new-scenario-content-body-row">
              <span className="save-new-scenario-content-body-name-title decarb-input-error-label">
                {ScenarioName}
                <span className="required-star">*</span>
                <Tooltip
                  trigger={<EmissionIcon />}
                  variant="ghost"
                  tooltipText={sceanrioNameTooltip}
                ></Tooltip>
              </span>
              <Input
                data-testid="scenario-name-input"
                value={simulate.scenarioName}
                disabled={simulate.scenarioID !== ""}
                errorMessage={senarioNameErrorMessage}
                isError={senarioNameErrorMessage}
                onChange={(e) => handleOnChange(e, "ScenarioName")}
                type="text"
              ></Input>
            </div>
            <div className="save-new-scenario-content-body-row">
              <span className="save-new-scenario-content-body-name-title decarb-input-error-label">
                {ScenarioDescription}
                <Tooltip
                  trigger={<EmissionIcon />}
                  variant="ghost"
                  tooltipText={scenarioDesctooltip}
                ></Tooltip>
              </span>
              <div style={{ flex: 1 }}>
                <TextArea
                  data-testid="scenario-name-textarea"
                  value={simulate.scenarioDescrption}
                  onChange={(e) => handleOnChange(e, "ScenarioDesc")}
                  disableErrorPlaceholder={false}
                  errorMessage={scenarioDescErrorMessage}
                  isError={scenarioDescErrorMessage}
                />
              </div>
            </div>
            {wafErrorFlag && <div className="waf-error-message">
              {wafErrorMessageState}
            </div>} 
          </div>
        </div>
      </LoadingIndicatorEmbed>
    </>
  );
}
